import React from "react";
import { motion } from "framer-motion";
import { Heat } from "./heat";
import { AppContext } from "../../App";

const Branch = ({ branch, setHeat, activeHeat, config, category }) => {
  const context = React.useContext(AppContext);
  const animationConfig = context.config.animation;
  const containerAnimation = {
    hidden: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.1,
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    }
  };


  return (
    <motion.div
      className="branch"
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
    >
      {branch &&
        branch.map(heat => {
          return (
            <Heat
              heat={heat}
              activeHeat={activeHeat}
              key={`heat-${heat.id}`}
              setHeat={setHeat}
              delay={
                config && config.delayInSeconds ? config.delayInSeconds : 60
              }
              category={category}
              config={config}
            />
          );
        })}
    </motion.div>
  );
};

export { Branch };
